import { creatorbase } from '@round/api';
import { useUpdateCampaignShareMutation } from '@round/creatorbase-helpers/api-hooks';
import useInvalidateProjectCampaignContext from '../../hooks/useInvalidateProjectCampaignContext';

type Campaign = Pick<creatorbase.Campaign, 'project_id' | 'platform'>;

// The response carries the sender's ids, so the project and platform to refresh come from the row.
export default function useUpdateReceivedCampaign(campaign: Campaign | null | undefined) {
    const invalidateProjectCampaignContext = useInvalidateProjectCampaignContext();

    return useUpdateCampaignShareMutation({
        onSuccess: async () => {
            if (!campaign) {
                return;
            }

            await invalidateProjectCampaignContext({
                project_id: campaign.project_id,
                platform: campaign.platform,
            });
        },
    });
}
